module.exports = __webpack_public_path__ + "static/media/banner-re2.8c3dc8af.png";